export const requestPasswordReset = async (
  email: string
) => {
  const { body } = await api.post<{ message: string }>(
    "/request-password-reset/",
    { body: { email } }
  )
  return body
}

type ResetPasswordBody = {
  token: string
  password: string
}

export const resetPassword = async (
  params: ResetPasswordBody
) => {
  const { body } = await api.post<{ message: string }>(
    "/handle-password-reset/",
    { body: params }
  )
  return body
}
